import { Component, Input, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { commonRoutes } from 'constants/web-app-constants';
import { TradeRoutes } from '../../util/trade-routes.enum';
import { TradeConfirmComponent } from '../trade-confirm/trade-confirm.component';
import { TradeCreateComponent } from '../trade-create/trade-create.component';
import { TradeSuccessComponent } from '../trade-success/trade-success.component';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'trade',
  imports: [TradeCreateComponent, TradeConfirmComponent, TradeSuccessComponent],
  templateUrl: './trade.component.html',
})
export class TradeComponent implements OnInit {
  @Input() public isin?: string;

  public tradeRoute: TradeRoutes = TradeRoutes.CREATE;
  public readonly ROUTES = TradeRoutes;
  public useCache = false;

  readonly #router = inject(Router);
  readonly #route = inject(ActivatedRoute);

  ngOnInit(): void {
    this.#route.queryParams.subscribe(() => (this.tradeRoute = TradeRoutes.CREATE));
  }

  public changeRoute = (route: TradeRoutes, useCache = false): void => {
    this.useCache = useCache;
    this.tradeRoute = route;
  };

  public async initTradeForm(queryParams: Params): Promise<void> {
    this.#router.navigate([commonRoutes.postlogin.buyAndSell], { queryParams });
  }
}
